import { s as t } from "../internals/set-to-string-tag.js";
t(Math, "Math", !0);